var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.47168,
    width: 41.0566,
    height: 41.0566,
    rx: 20.5283,
    fill: "#E63834"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6329 20.9912C30.6335 21.2652 30.5633 21.5346 30.429 21.7733C30.2947 22.0121 30.1009 22.212 29.8665 22.3536L15.3368 31.2421C15.0918 31.3921 14.8113 31.474 14.5241 31.4793C14.2369 31.4846 13.9535 31.4131 13.7031 31.2723C13.4552 31.1337 13.2486 30.9315 13.1047 30.6865C12.9608 30.4416 12.8847 30.1627 12.8843 29.8787V12.1038C12.8847 11.8197 12.9608 11.5409 13.1047 11.2959C13.2486 11.051 13.4552 10.8488 13.7031 10.7102C13.9535 10.5693 14.2369 10.4979 14.5241 10.5032C14.8113 10.5085 15.0918 10.5904 15.3368 10.7404L29.8665 19.6288C30.1009 19.7705 30.2947 19.9704 30.429 20.2092C30.5633 20.4479 30.6335 20.7173 30.6329 20.9912Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/video-play.67ddc0b6ae51773998bff3d481f7adb6.svg";
export { ForwardRef as ReactComponent };